import React from 'react';
import PropTypes from 'prop-types';
import MediaQuery from 'react-responsive';
import styles from './Color.module.sass';
import Button from '../../../ui_kit/button/Button';
import BackButton from '../back_button/BackButton';
import ColorBlock from './color_block/ColorBlock';
import COLORS from '../../constants/colors';
import Help from './help/Help';
import BREAKPOINTS from '../../constants/breakpoints';

function Color(props) {
  const {
    increaseStep, decreaseStep, quiz, step, updateQuiz,
  } = props;

  const { color } = quiz;

  const setColor = (newColor) => {
    updateQuiz({ ...quiz, color: newColor });
  };

  const onNextClick = () => {
    increaseStep({ ...quiz, color });
  };

  return (
    <>
      <BackButton decreaseStep={() => { decreaseStep({ ...quiz, color }); }} />
      <div className={styles.color}>
        <div className={styles.content}>
          {step}
          { !step && <div className={styles['top-spacing']} />}
          <h1 className={styles.title}>
            Choose the hue that makes it you.
          </h1>
          <div className={styles.description}>
            Customize your campaign and join the color collective.
            Submit an idea for a new product and select your color.
            Every idea creates a pixel in the grid that is Volition.
          </div>
          <div className={styles.row}>
            <div className={styles.colors}>
              {COLORS.map((hexColor) => (
                <ColorBlock
                  key={hexColor}
                  setColor={() => { setColor(hexColor); }}
                  color={hexColor}
                  selectedColor={color}
                />
              ))}
            </div>
            <MediaQuery query={`(min-width: ${BREAKPOINTS.DESKTOP_WIDTH_BREAKPOINT}px)`}>
              <Help />
            </MediaQuery>
          </div>
          <Button
            className={`${styles.button} custom-transparent-button`}
            onClickHandler={onNextClick}
            disabled={!color}
            text="NEXT"
            color="transparent-blue"
            size="small"
          />
        </div>
        <MediaQuery query={`(max-width: ${BREAKPOINTS.DESKTOP_WIDTH_BREAKPOINT - 1}px)`}>
          <Help />
        </MediaQuery>
      </div>
    </>
  );
}

Color.propTypes = {
  increaseStep: PropTypes.func.isRequired,
  decreaseStep: PropTypes.func.isRequired,
  updateQuiz: PropTypes.func.isRequired,
  quiz: PropTypes.shape({
    color: PropTypes.string,
  }).isRequired,
  step: PropTypes.node,
};

export default Color;
